import * as React from 'react';
import { useEffect, useState } from 'react';
import { Route, Switch, useRouteMatch, useLocation, useHistory } from 'react-router';
import { RouterContext } from '../context/RouterContext';
const Router = ({ router }) => {
    const match = useRouteMatch();
    const history = useHistory();
    const location = useLocation();
    const basePath = match.path.replace(`/${router.path}`, '');
    const Layout = router.layout || React.Fragment;
    const [currentPath, setCurrentPath] = useState(router.path);
    useEffect(() => {
        const routePath = location.pathname.replace(basePath, '');
        setCurrentPath(routePath);
    }, [location]);
    const navigate = (to, options = {}) => {
        const { state, replace } = options;
        const navigatePath = `${basePath}${to}`;
        if (replace) {
            history.replace(navigatePath, state);
        }
        else {
            history.push(navigatePath, state);
        }
    };
    return (React.createElement(RouterContext.Provider, { value: { basePath, currentPath, navigate } },
        React.createElement(Switch, null, router.children.map(({ element, path, index, exact }) => {
            const routePath = index ? router.path : `${router.path}/${path}`;
            const routeFullPath = `${basePath}/${routePath}`;
            return (React.createElement(Route, { key: routeFullPath, path: routeFullPath, exact: index || exact },
                React.createElement(Layout, null, element)));
        }))));
};
export default Router;
